import EventBus from "@/event-bus";

export const Cardinal = {
  instance: null,
  start: null,
  complete: null,
  configure: null,
  continue: null,
  setup: null,
};

function init() {
  if (window.Cardinal === undefined && Cardinal.instance === null) {
    console.log("CardinalCommerce library not loaded.");
    return false;
  } else if (Cardinal.instance === null) {
    Cardinal.instance = window.Cardinal;
  }

  return true;
}

export function create(options = {}) {
  if (!init(options || {})) {
    return Cardinal;
  }

  Cardinal.start = (options) => Cardinal.instance.start(options);
  Cardinal.complete = (options) => Cardinal.instance.complete(options);
  Cardinal.configure = (options) => Cardinal.instance.configure(options);
  Cardinal.continue = (options) => Cardinal.instance.continue(options);
  Cardinal.setup = (v, options) => Cardinal.instance.setup(v, options);
  Cardinal.on = (e, options) => Cardinal.instance.on(e, options);

  Cardinal.on("payments.validated", (data, jwt) => {
    EventBus.$emit("cardinal-payments-validated", { data: data, jwt: jwt });
  });

  return Cardinal;
}

create();
